import * as Yup from 'yup'

export const ConnectValidationSchema = Yup.object().shape({
  apiKey: Yup.string().required(),
})
